import React, { Dispatch, SetStateAction, useRef, useState } from 'react';
import classnames from 'classnames';
import md5 from 'crypto-js/md5';
import { Loading } from '@/components';
import { i18n, loadHTMLImage } from '@/utils';
import { getFaceData } from '.';
import { UserImage, ResponseAvatar } from './mini-me';
import Icon from './icon';
import styles from './style.less';

interface ChooseAvatarProps {
  /** 分割的头像数据 */
  avatars: ResponseAvatar[];
  /** 设置 zuploader 组件显影 */
  setZuploaderVisible: Dispatch<SetStateAction<boolean>>;
  /** 确认回调 */
  onConfirm: (image: ResponseAvatar, htmlImage: HTMLImageElement, faceRecognizeData: UserImage['faceRecognizeData'] | undefined) => void;
  /** 关闭回调 */
  onClose: () => void;
}

const ChooseAvatar: React.FC<ChooseAvatarProps> = ({ avatars, setZuploaderVisible, onConfirm, onClose }) => {

  /** 当前请求图片的 key */
  const currentKey = useRef<string>('');
  /** 当前选中的头像下标 */
  const [ selectedFace, setSelectedFace ] = useState<number>();
  /** 人脸识别加载 */
  const [ loading, setLoading ] = useState<boolean>(false);

  /** 点击选中人脸 */
  const handleSelectedFace = async (face: ResponseAvatar, index: number) => {
    setLoading(true);
    setSelectedFace(index);
    const key = md5(face.image).toString();
    currentKey.current = key;
    const [ image, faceRecognizeData ] = await Promise.all([
      loadHTMLImage(face.image),
      getFaceData(face.image),
    ]);
    if (currentKey.current === key) {
      onConfirm(face, image, faceRecognizeData);
    }
  }

  return (
    <div className={styles.chooseAvatar}>
      <div className={styles.chooseAvatarClose} onClick={onClose}>
        <Icon type="close" color="#000" size={30} />
      </div>
      <div className={styles.chooseAvatarTitle}>{i18n.format('modules.mini.me.choose.avatar.title')}</div>
      <div className={styles.chooseAvatarContent}>
        <div className={styles.chooseAvatarContentOptions}>
          {avatars.map((item, index) => (
            <div
              key={index}
              className={classnames(styles.avatarWrapper, {
                [styles.avatarSelected]: selectedFace === index,
              })}
              onClick={() => handleSelectedFace(item, index)}
            >
              {(loading && selectedFace === index) &&
                <div className={styles.loadingWrapper}>
                  <Loading color="#ff533a" />
                </div>
              }
              <img src={item.image} />
            </div>
          ))}
        </div>
        <div className={styles.chooseAvatarContentReplace} onClick={() => setZuploaderVisible(true)}>
          {`${i18n.format('modules.mini.me.choose.avatar.replace')} →`}
        </div>
      </div>
    </div>
  );
}

export default ChooseAvatar;
